import dayjs from "dayjs";

/** YYYY-MM-DD للاستخدام في مسارات API (attendancelog / discounts-list / wages-list) */
export function formatApiDate(value) {
  if (value == null || value === "") return "";
  if (dayjs.isDayjs(value)) {
    return value.isValid() ? value.format("YYYY-MM-DD") : "";
  }
  const d = dayjs(value);
  return d.isValid() ? d.format("YYYY-MM-DD") : "";
}

export function isValidApiDateRange(start, end) {
  const s = formatApiDate(start);
  const e = formatApiDate(end);
  return (
    s !== "" &&
    e !== "" &&
    s !== "Invalid Date" &&
    e !== "Invalid Date" &&
    dayjs(s, "YYYY-MM-DD", true).isValid() &&
    dayjs(e, "YYYY-MM-DD", true).isValid()
  );
}

/** فترة الرواتب الافتراضية من إعدادات admin.month_start / month_end */
export function getDefaultPayrollRange(settings, referenceMonth = dayjs()) {
  const monthStart =
    settings?.find((item) => item.key === "admin.month_start")?.value || "1";
  const monthEnd =
    settings?.find((item) => item.key === "admin.month_end")?.value || "30";
  const ref = dayjs.isDayjs(referenceMonth) ? referenceMonth : dayjs(referenceMonth);
  const ym = ref.isValid() ? ref.format("YYYY-MM") : dayjs().format("YYYY-MM");

  const start = dayjs(`${ym}-${monthStart}`, "YYYY-MM-DD")
    .subtract(1, "month")
    .format("YYYY-MM-DD");
  const end = dayjs(`${ym}-${monthEnd}`, "YYYY-MM-DD").format("YYYY-MM-DD");

  return { start, end };
}

/** عند اختيار شهر من DatePicker (picker=month) */
export function getPayrollRangeForMonth(monthValue, settings) {
  const monthStart =
    settings?.find((item) => item.key === "admin.month_start")?.value || "1";
  const monthEnd =
    settings?.find((item) => item.key === "admin.month_end")?.value || "30";

  let ym = "";
  if (dayjs.isDayjs(monthValue) && monthValue.isValid()) {
    ym = monthValue.format("YYYY-MM");
  } else if (typeof monthValue === "string" && monthValue.length >= 7) {
    ym = dayjs(monthValue).isValid()
      ? dayjs(monthValue).format("YYYY-MM")
      : monthValue.slice(0, 7);
  } else {
    ym = dayjs().format("YYYY-MM");
  }

  const start = dayjs(`${ym}-${monthStart}`, "YYYY-MM-DD")
    .subtract(1, "month")
    .format("YYYY-MM-DD");
  const end = dayjs(`${ym}-${monthEnd}`, "YYYY-MM-DD").format("YYYY-MM-DD");

  return { start, end };
}

/** RangePicker onChange → نطاق API موحّد */
export function rangeFromPicker(dates, dateStrings) {
  if (!dates?.[0] || !dates?.[1]) {
    return null;
  }
  const start =
    formatApiDate(dateStrings?.[0]) || formatApiDate(dates[0]);
  const end =
    formatApiDate(dateStrings?.[1]) || formatApiDate(dates[1]);
  if (!start || !end) return null;
  if (dayjs(start).isAfter(dayjs(end))) {
    return { start: end, end: start };
  }
  return { start, end };
}
